import classes from "./HeaderSimple.module.css";
import viewnet from "../../images/viewnet.png";

export function HeaderSimple() {
  return (
    <header className={classes.header}>
      <img src={viewnet} alt="ViewNet" className={classes.viewnet} />
    </header>
  );
}
